import React from 'react';
import ServicesSection from '../components/ServicesSection';

const ServicesPage = () => {
  return (
    <>
      <ServicesSection />
    </>
  );
};

export default ServicesPage;